module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-600.a6476bc0.png";